import { useCallback, useState } from 'react';

export type EnumOrObject<T> = T extends Record<string, number> ? T : never;

export interface UseTileDrawerStepper<Steps extends EnumOrObject<any>> {
  steps: Steps;
}

const useTileDrawerStepper = <Steps extends EnumOrObject<any>>({ steps }: UseTileDrawerStepper<Steps>) => {
  const [currentStep, setCurrentStep] = useState<Steps[keyof Steps]>(() => {
    const firstStep = Object.values(steps)[0] as Steps[keyof Steps];
    return firstStep;
  });

  const goToStep = useCallback((step: Steps[keyof Steps]) => {
    setCurrentStep(step);
  }, []);

  const goToPreviousStep = useCallback(() => {
    setCurrentStep((prevStep) => {
      const stepValues = Object.values(steps) as Steps[keyof Steps][];
      const currentIndex = stepValues.indexOf(prevStep);
      const newIndex = currentIndex === 0 ? 0 : currentIndex - 1;
      return stepValues[newIndex];
    });
  }, []);

  const goToNextStep = useCallback(() => {
    setCurrentStep((prevStep) => {
      const stepValues = Object.values(steps) as Steps[keyof Steps][];
      const currentIndex = stepValues.indexOf(prevStep);
      const newIndex = currentIndex === stepValues.length - 1 ? currentIndex : currentIndex + 1;
      return stepValues[newIndex];
    });
  }, [steps]);

  return {
    currentStep,
    goToStep,
    goToPreviousStep,
    goToNextStep,
  };
};

export default useTileDrawerStepper;
